import React, { useState, useEffect } from "react";
import "./Subscriptions.scss";
import axiosInstance from "../axiosInstance";

const Subscriptions = () => {
  const [purchaseDetails, setPurchaseDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Fetch data from the endpoint
    const fetchPurchaseDetails = async () => {
      try {
        // Use axiosInstance to make the GET request
        const response = await axiosInstance.get(
          `${process.env.REACT_APP_API_BASE_URL}/purchase-details/latest`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        // Check if the response status is not OK
        if (response.status !== 200) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        // Parse the response data
        const result = response.data;

        if (result.status === 200) {
          setPurchaseDetails(result.data);
          console.log(purchaseDetails);
        } else {
          throw new Error(result.message || "Failed to fetch data");
        }
      } catch (err) {
        console.error("Error fetching purchase details:", err); // Log the error to the console
        setError(err.message); // Update the error state for display if needed
      } finally {
        setLoading(false); // Set loading state to false after API call
      }
    };

    fetchPurchaseDetails();
  }, []);

  if (loading) {
    return <div className="subscriptions">Loading...</div>;
  }

  if (error) {
    return <div className="subscriptions error">{error}</div>;
  }

  return (
    <div className="subsctiption">
      <h1 className="display6">Purchase Details</h1>
      <div className="card-container">
        {purchaseDetails.map((detail) => (
          <div key={detail.purchaseDetailsId} className="card">
            <p>
              <strong>Modules:</strong> {detail.modules.join(", ")}
            </p>
            <p>
              <strong>Total Users:</strong> {detail.totalUsers}
            </p>
            <p>
              <strong>Current Users:</strong> {detail.currentUsers}
            </p>
            <p>
              <strong>Subscription Type:</strong> {detail.subscriptionType}
            </p>
            <p>
              <strong>Month Plan:</strong> {detail.monthPlan}
            </p>
            <p>
              <strong>Expiry Date:</strong>{" "}
              {new Date(detail.expiryDate).toLocaleDateString()}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Subscriptions;
